<template>
    <div class="transfer-topbar" :class="theme">
        <div class="wrapper d-flex">
            <div class="btn-back d-flex"  @click="clickBackHome()">
                <img v-if="stage != 'result'" src="@/module/YesCoin/assets/yc-bk-back.svg" />
            </div>
            <!-- <div class="logo d-flex">
                <img src="../../assets/logo-shopee.svg" />
            </div> -->
        </div>
    </div>
</template>
<script>

export default {
    name: "Topbar",
    props: {
        theme: String,
        stage: String
    },
    components: {

    },
    data: function() {
        return {
        }
    },
    created: function() {

    },
    mounted: function() {

    },
    methods: {
        clickBackHome: function() {
            this.$emit("clickBack");
        },
    }
}
</script>
<style lang="scss" scoped>
@import "../../style/base.scss";
@import "style/TopBar.scss";
</style>

